
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "../../newStyle.css";
import { useNavigate } from "react-router-dom";
import SearchBox from "../../../../Components/SearchBox";
import { Formik } from "formik";

import { useQuery } from "@tanstack/react-query";
import { GetCategoryList } from "../../../../Api/category"
import { CategorySearchBarInitialValues } from "../../constant";
import {
  Confirmation,
  ErrorToast,
  SuccessToast,
} from "../../../../Utils/SweetAlert";
import { useMutateDeleteCategory } from "../../hooks/useApiHook"
import Pagination from "../../../../Utils";
import AddButton from "../../../../Components/AddButton";
import { EditButton, DeleteButton } from "../../../../Components";

const CategoryList = () => {
  const navigate = useNavigate();
  const formRef = useRef();

  const deleteCategory = useMutateDeleteCategory();

  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState(null);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const {
    isFetching: isCategoryLoading,
    data: categoryList,
    refetch,
  } = useQuery({
    queryKey: ["get-category-list", page, limit],
    queryFn: () =>
      GetCategoryList({
        limit: limit,
        page: page === 0 ? 1 : page + 1,
        search: formRef?.current?.values?.search,
      }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
    refetch();
  };

  const handleLimitChange = async (event) => {
    setPage(0);
    setLimit(parseInt(event.target.value, 10));
    refetch();
  };

  return (
    <>
      <Helmet>
        <title>OVE | Admin Category </title>
      </Helmet>
      <div className="page-wrapper category">
        <div className="content container-fluid">
          <div className="admin-wrapper">
            <div className="page-header">
              <div className="col">
                <h1 className="page-title">Category</h1>
              </div>
              <div className="col-12 col-md-3 col-lg-2 px-2">
                <Formik
                  initialValues={CategorySearchBarInitialValues}
                  innerRef={formRef}
                >
                  {() => {
                    return (
                      <form>
                        <SearchBox refetch={refetch} setPage={setPage} />
                      </form>
                    );
                  }}
                </Formik>
              </div>
              <div>
                <AddButton
                  to="/admin/add-category"
                  permission="create-category"
                />
              </div>
            </div>
            <div className="col-sm-12 table-width">
              <div className="cards-table card-table">
                <div className="card-body">
                  <div className="table-responsive category-table custom-pagination table-no-padding">
                    <table className="table datatable table-manager mb-0" style={{ width: '100%' }}>
                      <thead className="thead-light">
                        <tr>
                          <th className="col-image text-start" style={{ width: '10%' }}>Image</th>
                          <th className="col-name text-start" style={{ width: '20%' }}>Name</th>
                          <th className="col-parent text-start" style={{ width: '25%' }}>Parent Category</th>
                          <th className="col-guide text-start" style={{ width: '26%' }}>Guide Product</th>
                          <th className="col-action text-center" style={{ width: '19%' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isCategoryLoading && (
                          <tr>
                            <td align="center" colSpan={5}>
                              <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border loader-theme" role="status" />
                              </div>
                            </td>
                          </tr>
                        )}
                        {!isCategoryLoading && categoryList !== undefined && (
                          <>
                            {categoryList?.data?.data.map((item, index) => {
                              return (
                                <tr key={index} className="table disable-row">
                                  <td className="col-image text-start">
                                    {item?.imageUrl ? (
                                      <img
                                        src={item?.imageUrl}
                                        alt="category"
                                        className="list-image-news"
                                        style={{ width: '40px', height: '40px', borderRadius: '5px', objectFit: 'cover' }}
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td className="col-name text-start">
                                    <span className="category-cell-ellipsis">{item?.name || "-"}</span>
                                  </td>
                                  <td className="col-parent text-start">
                                    <span className="category-cell-ellipsis">{item?.parentCategoryId?.name || "-"}</span>
                                  </td>
                                  <td className="col-guide text-start">
                                    <span className="category-cell-ellipsis">{item?.guideProductId?.name || "-"}</span>
                                  </td>
                                  <td className="category-td-padding-remove col-action text-center">
                                    <EditButton
                                      to="/admin/edit-category"
                                      state={{ id: item?._id }}
                                      permission="edit-category"
                                    />
                                    <DeleteButton
                                      onDelete={() => {
                                        Confirmation("Are you sure you want to delete category?").then(
                                          async (deleteConfirm) => {
                                            if (deleteConfirm.isConfirmed) {
                                              deleteCategory.mutate(item?._id, {
                                                onSuccess: (response) => {
                                                  if (response?.status != 0) {
                                                    SuccessToast(response?.message || "Delete Successful.");
                                                    refetch();
                                                  } else {
                                                    ErrorToast(response?.message || "Server Error.");
                                                  }
                                                },
                                                onError: (error) => {
                                                  ErrorToast(error?.response?.data?.message || "Server Error.");
                                                },
                                              });
                                            }
                                          }
                                        );
                                      }}
                                      permission="delete-category"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                            {categoryList?.data?.data?.length === 0 && (
                              <tr>
                                <td className="text-center" colSpan={5}>
                                  No Records Found.
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Pagination
              totalItem={categoryList?.data?.totalRecords || 0}
              itemsPerPage={limit}
              page={
                !categoryList?.data?.totalRecords ||
                  categoryList?.data?.totalRecords <= 0
                  ? 0
                  : page
              }
              handleChangePage={handlePageChange}
              handleChangeRowsPerPage={handleLimitChange}
              colSpan={5}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default CategoryList;
